import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import 'tiny-warning';
import { RenderComp } from '../core/render-comp.component.js';
import { DropdownWithFloatingLabelContext } from './dropdown.context.js';
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
const propTypes = {
  fullWidth: PropTypes.bool
};
const DropdownWithFloatingLabel = renderWithRef('DropdownWithFloatingLabel', propTypes, (props, ref) => {
  const {
      fullWidth = false,
      children
    } = props,
    rest = _objectWithoutProperties(props, ["fullWidth", "children"]);
  const classNames = new Set(['swan-vanilla-ignore', 'swan-dropdown-with-floating-label']);
  if (fullWidth) classNames.add("swan-dropdown-with-floating-label-full-width");
  const [dropdownId, setDropdownId] = React.useState();
  const [dropdownElem, setDropdownElem] = React.useState();
  return /*#__PURE__*/React.createElement(DropdownWithFloatingLabelContext.Provider, {
    value: {
      dropdownId,
      setDropdownId,
      dropdownElem: dropdownElem,
      setDropdownElem: setDropdownElem
    }
  }, /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    props: rest,
    classNames: classNames
  }, children));
});
export { DropdownWithFloatingLabel };